import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Spinner } from 'react-bootstrap'
import { useLazyQuery } from '@apollo/client'
import useTranslation from 'next-translate/useTranslation'

import Layout from '@shared/components/layout'
import { LIST_WEB_STORIES } from '@graphql/web-stories/web-stories.query'
import { isBottomReached } from '@shared/utils'

const Ads = dynamic(() => import('@shared/components/ads'))
const Stories = dynamic(() => import('@shared/components/stories'))
const NoData = dynamic(() => import('@shared/components/noData'))
const PageHeader = dynamic(() => import('@shared/components/pageHeader'))
// const StoriesLightBox = dynamic(() => import('@shared/components/stories/stories-light-box'))

function WebStories({ seoData, stories }) {
  const { t } = useTranslation()
  const payload = useRef({ nSkip: 1, nLimit: 16 })
  const total = useRef(payload.current.nLimit)
  const isLoading = useRef(false)
  const [list, setList] = useState(stories)

  const [getStories, { data, loading }] = useLazyQuery(LIST_WEB_STORIES)

  useEffect(() => {
    isLoading.current = false
    isBottomReached(list[list.length - 1]?._id, isReached)
  }, [list])

  useEffect(() => {
    if (data?.listWebStoryFront?.aWebStory) handleResponce(data?.listWebStoryFront?.aWebStory)
  }, [data])

  function isReached(reach) {
    if (reach && !isLoading.current && total.current === payload.current.nLimit) {
      isLoading.current = true
      payload.current.nSkip += 1
      getStories({
        variables: { input: { ...payload.current } }
      })
    }
  }

  function handleResponce(d = []) {
    total.current = d?.length
    setList([...list, ...d])
  }

  return (
    <main className="my-3 my-md-4">
      <Layout data={{ oSeo: seoData }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-9 left-content">
              <PageHeader seoData={seoData} name={t('common:CricStories')} />
              {/* <StoriesLightBox data={list} /> */}
              <div className="row g-1" id="enable-stories-player">
                {list?.map((e) => (
                  <div key={e?._id} className="col-md-3 col-sm-4 col-6" id={e?._id}>
                    <Stories data={e} className="w-100" />
                  </div>
                ))}
                {list?.length === 0 && <NoData />}
              </div>
              {loading && (
                <div className="text-center mt-3">
                  <Spinner animation="border" size="md" />
                </div>
              )}
            </div>
            <div className="col-lg-3 common-sidebar d-none d-lg-block">
              <Ads
                id="div-ad-gpt-138639789-1646636827-0"
                adIdDesktop="Crictracker_New_Desktop_AP_RightMID_300x600"
                slotId="23148549803"
                dimensionDesktop={[300, 600]}
                className="sticky-ads position-sticky mb-2"
              />
            </div>
          </div>
        </div>
      </Layout>
    </main>
  )
}
WebStories.propTypes = {
  stories: PropTypes.array,
  seoData: PropTypes.object
}
export default WebStories

export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  const [utils, graphql, articleQuery] = await Promise.all([
    import('@shared/utils'),
    import('@shared-components/queryGraphql'),
    import('@graphql/article/article.query')
  ])

  try {
    // const slug = params?.slug?.join('/')
    const [seo, stories] = await Promise.allSettled([
      graphql?.default(articleQuery.GET_ARTICLE_ID, { input: { sSlug: 'web-stories' } }),
      graphql?.default(LIST_WEB_STORIES, { input: { nSkip: 0, nLimit: 16 } })
    ])
    res.setHeader('Cache-Control', 'public, max-age=600')
    return {
      props: {
        seoData: seo.value?.data?.getSeoData || {},
        stories: stories?.value?.data?.listWebStoryFront?.aWebStory || []
      }
    }
  } catch (e) {
    // console.log({ slug: e })
    res.setHeader('Cache-Control', 'no-cache')
    const status = utils.handleApiError(e, resolvedUrl)
    return status
  }
}
